import { render, staticRenderFns } from "./createObservationPoint.vue?vue&type=template&id=f22e8cb2&scoped=true&"
import script from "./createObservationPoint.vue?vue&type=script&lang=js&"
export * from "./createObservationPoint.vue?vue&type=script&lang=js&"
import style0 from "./createObservationPoint.vue?vue&type=style&index=0&id=f22e8cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22e8cb2",
  null
  
)

export default component.exports